import { CustomLinearProgress } from "./LinearProgress.styles";

const LinearProgress = ({ ...rest }) => {
  return <CustomLinearProgress {...rest} />;
};
export { LinearProgress };
